export const JOB_LIST = 'JOB_LIST'
export const ACTIVE_JOB = 'ACTIVE_JOB'
